import { Injectable } from '@angular/core';
import { Http, Request, RequestMethod, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';



@Injectable()
export class AuthHttp {

  private sessionId: string;

  constructor(
    private http: Http,
    private authService: AuthService,
    private defaultRequestOptions?: RequestOptions
  ) {
    this.authService.getSession().subscribe((session) => {
      if (session && session.sessionId) {
        this.sessionId = session.sessionId;
      }
    });
  }

  public request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    if (typeof url === 'string') {
      return this.get(url, options); // Recursion: transform url from String to Request
    }

    // from this point url is always an instance of Request;
    const req: Request = url as Request;

    if (this.sessionId) {
      req.headers.set('Bonanza-Session-Id', this.sessionId);
    }

    return this.http.request(req);
  }

  public get(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.requestHelper({ body: '', method: RequestMethod.Get, url: url }, options);
  }

  public post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.requestHelper({ body: body, method: RequestMethod.Post, url: url}, options);
  }

  public put(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.requestHelper({ body: body, method: RequestMethod.Put, url: url }, options);
  }

  public delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.requestHelper({ body: '', method: RequestMethod.Delete, url: url }, options);
  }

  public patch(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
    return this.requestHelper({ body: body, method: RequestMethod.Patch, url: url }, options);
  }

  public head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.requestHelper({ body: '', method: RequestMethod.Head, url: url }, options);
  }

  public options(url: string, options?: RequestOptionsArgs): Observable<Response> {
    return this.requestHelper({ body: '', method: RequestMethod.Options, url: url }, options);
  }

  private mergeOptions(providedOpts: RequestOptionsArgs, defaultOptions?: RequestOptions): RequestOptions {
    let newOptions = defaultOptions || new RequestOptions();
    newOptions = newOptions.merge(new RequestOptions(providedOpts));

    return newOptions;
  }

  private requestHelper(requestArgs: RequestOptionsArgs, additionalOptions?: RequestOptionsArgs): Observable<Response> {
    if (requestArgs.url && !requestArgs.url.startsWith(environment.apiBaseUrl)) {
      requestArgs.url = environment.apiBaseUrl + requestArgs.url;
    }

    let options = new RequestOptions(requestArgs);
    if (additionalOptions) {
      options = options.merge(additionalOptions);
    }

    return this.request(new Request(this.mergeOptions(options, this.defaultRequestOptions)));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/auth-http.service.ts